import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { Location } from "@angular/common";
import {
  AssigmentDealerModel,
  AssigmentService,
  CreateDealerBalanceRQ,
  DealerBalanceService,
  DealerModel,
  DealersModelDetails,
  DealerService,
  ShippingListModel,
  ShippingService,
  FlightListModel,
  FlightService,
  BillService,
  ListFlightByShippingRQ
} from "app/open-api";
import { GetDispatchByIdRQ, GetDispatchByIdRP} from './../../open-api/model/getDispatchByIdRQ';
import { AssigmentDealerLocalModel, AssigmentDealerToExport } from 'app/shared/models/assigment-dealer.model';
import { environment } from 'environments/environment';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ShippingListRQ } from '../../open-api/model/ShippingListRQ';
import { GetBillsForDispatchRQ } from './../../open-api/model/getBillsForDispatchRQ';
import { ListDispatchByParamsRQ, ListDispatchByParamsRP, DispatchBillModel, DispatchModel } from './../../open-api/model/listDispatchByParamsRQ';
import { AddDispatchToDealerRQ } from './../../open-api/model/addDispatchToDealerRQ';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateDispatchToDealerRQ } from 'app/open-api/model/updateDispatchToDealerRQ';
import { ShippingType, shippingTypes } from 'app/open-api/model/shippingType';
import { DispatchBillsPreviewComponent } from 'app/shared/components/dispatch-bills-preview/dispatch-bills-preview.component';
import { PreviewDispatchResult } from 'app/open-api/model/previewDispatchResult';

@Component({
  selector: "app-dealer-dispatchs",
  templateUrl: "./dealer-dispatchs.component.html",
  styleUrls: ["./dealer-dispatchs.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class DealerDispatchsComponent implements OnInit {
  public shippings: ShippingListModel[] = [];
  public dealers: DealersModelDetails[] = [];
  public assigments: AssigmentDealerModel[] = [];
  flights: FlightListModel[] = [];
  public searchForm: FormGroup;
  public filterForm: FormGroup;
  public assignments: AssigmentDealerLocalModel[] = [];
  selectedAssignment: AssigmentDealerLocalModel;
  selectedBillAssignments: AssigmentDealerLocalModel[] = [];
  public allAssignments: AssigmentDealerLocalModel[] = [];
  //public dealers: DealerModel[] = [];
  selectedDealerId = "";
  dispatchs: DispatchModel[] = [];
  selectedDispatch: DispatchModel;
  public ColumnMode = ColumnMode;
  urlApi = environment.apiUrl;
  public basicSelectedOption: number = 5;
  searchForDealer: GetBillsForDispatchRQ;
  selected = [];
  selectedRowIds = new Set<string>();
  canCheck: false;
  public SelectionType = SelectionType;
  dealerId = "";
  dispatchId = "";
  headerMessage = "";
  selectedShippingType: string;
  shippingTypes: Array<ShippingType> = [];
  public placeholder: string = "Entre el codigo";
  public keyword = "name";
  public historyHeading: string = "Recently selected";
  //public selected: any[] = [];

  constructor(
    private assigmentService: AssigmentService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private billService: BillService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private dealerService: DealerService,
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location
  ) {
    this.shippingTypes = shippingTypes;

    this.searchForm = new FormGroup({
      dealerId: new FormControl(null, [
        Validators.required,
        Validators.maxLength(15),
      ]),
      name: new FormControl(null, Validators.required),
    });

    this.filterForm = new FormGroup({
      shippingType: new FormControl(null),
      billCode: new FormControl(null),
      flightCode: new FormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    await this.FetchDealers();

    await this.route.params.subscribe(async (params) => {
      this.dispatchId = params["dispatchId"];

      if (this.dispatchId) {
        this.headerMessage = "Actualizar despacho";
        await this.FetchDispatch();
        //this.FetchModels();
      } else {
        this.headerMessage = "Nuevo despacho";
        this.spinner.hide();
      }
    });
  }

  UpdateFormFields() {
    if (this.selectedDispatch && this.selectedDispatch != null) {
      if (this.selectedDispatch.dispatchBills.length > 0)
        this.searchForm.controls["dealerId"].disable();

      this.searchForm.get("dealerId").setValue(this.selectedDispatch.dealer.id);
      this.searchForm.get("name").setValue(this.selectedDispatch.name);
      this.selectedDealerId = this.selectedDispatch.dealer.id.toString();
    }
  }

  cleanDispatchFields() {
    this.searchForm.get("dealerId").setValue(null);
    this.searchForm.get("name").setValue(null);
  }

  onChangeBillCode(val: any) {
    if (val != "") {
      if (
        this.selectedShippingType != "" &&
        this.selectedShippingType != null
      ) {
        let filterRecords = this.allAssignments.filter(
          (item) => item.shippingType == +this.selectedShippingType
        );

        filterRecords = filterRecords.filter((item) =>
          item.billCode.toLocaleLowerCase().includes(val.toLocaleLowerCase())
        );

        this.billCodesFiltered = filterRecords.map((item) => item.billCode);
      } else {
        let filterRecords = this.allAssignments.filter((item) =>
          item.billCode.toLocaleLowerCase().includes(val.toLocaleLowerCase())
        );
        this.billCodesFiltered = Array.from(
          new Set(filterRecords.map((item) => item.billCode))
        );
      }
    } else this.billCodesFiltered = [];
  }

  onChangeFlightCode(val: any) {
    if (val != "") {
      if (
        this.selectedShippingType != "" &&
        this.selectedShippingType != null
      ) {
        let filterRecords = this.allAssignments.filter(
          (item) => item.shippingType == +this.selectedShippingType
        );

        filterRecords = filterRecords.filter((item) =>
          item.flightCode.toLocaleLowerCase().includes(val.toLocaleLowerCase())
        );
        this.flightCodesFiltered = filterRecords.map((item) => item.flightCode);
      } else {
        let filterRecords = this.allAssignments.filter((item) =>
          item.flightCode.toLocaleLowerCase().includes(val.toLocaleLowerCase())
        );
        this.flightCodesFiltered = Array.from(
          new Set(filterRecords.map((item) => item.flightCode))
        );
      }
    } else this.flightCodesFiltered = [];
  }

  public billCodesFiltered = [];
  public flightCodesFiltered = [];

  resetTiposEnvio() {}

  resetBillCodes() {
    this.billCodesFiltered = [];
  }

  resetFlightCodes() {
    this.flightCodesFiltered = [];
  }

  FetchShippingsByType() {
    if (this.filterForm.get("shippingType").value != null) {
      this.selectedShippingType =
        this.filterForm.controls["shippingType"].value.toString();
    }
  }

  get f() {
    return this.searchForm.controls;
  }

  async FetchDealers() {
    const request: ShippingListRQ = {};

    await this.dealerService
      .apiDealerDetailsListGet()
      .toPromise()
      .then((response) => {
        this.dealers = response.list;
      }),
      (error) => {
        Swal.fire({
          title: "Error!. " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      };
  }

  GetDealer() {    
    let dealerBill = this.dealers.find(
      (item) => item.id === +this.selectedDealerId
    );
    return dealerBill;
  }

  GetNameShippingType(type: number) {
    return this.shippingTypes.find((b) => b.id === type).name;
  }

  Back(): void {
    this._location.back();
  }

  get fd() {
    return this.searchForm.controls;
  }

  resetFilters() {
    this.assignments = this.allAssignments;
    this.filterForm.get("billCode").setValue(null);
    this.filterForm.get("flightCode").setValue(null);
    this.selectedShippingType = null;
    this.filterForm.get("shippingType").setValue(null);
  }

  Filter() {
    let shippingType =
      this.selectedShippingType != null && this.selectedShippingType != ""
        ? this.selectedShippingType
        : "";
    let billCode =
      this.filterForm.get("billCode").value != null &&
      this.filterForm.get("billCode").value != ""
        ? this.filterForm.get("billCode").value
        : "";
    let flightCode =
      this.filterForm.get("flightCode").value != null &&
      this.filterForm.get("flightCode").value != ""
        ? this.filterForm.get("flightCode").value
        : "";

    this.assignments = this.allAssignments.filter(
      (bill) =>
        (bill.billCode
          ?.toLocaleLowerCase()
          .includes(billCode?.toLocaleLowerCase() || "") ||
          bill.serviceCode
            ?.toLocaleLowerCase()
            .includes(billCode?.toLocaleLowerCase() || "")) &&
        bill.flightCode
          ?.toLocaleLowerCase()
          .includes(flightCode?.toLocaleLowerCase() || "") &&
        (shippingType !== "" ? bill.shippingType! === +shippingType : true)
    );
  }

  OnDealerChange() {
    if (
      this.searchForm.get("dealerId").value != null &&
      this.searchForm.get("dealerId").value != ""
    ) {
      this.selectedDealerId = this.searchForm.get("dealerId").value;
      this.spinner.show();
      //this.searchForDealer = this.searchForm.value;
      const request: GetBillsForDispatchRQ = {
        dealerId: this.selectedDealerId ? +this.selectedDealerId : null,
        dispatchId: this.dispatchId ? +this.dispatchId : null,
        isForUpdate: this.dispatchId ? true : false,
      };
      
      this.assigmentService.apiAssigmentListForDispatchPost(request).subscribe(
        (response) => {
          this.selectedRowIds.clear();
          this.assignments = this.ModelParse(response.list);
          this.allAssignments = this.ModelParse(response.list);
          this.selected = this.selectedBillAssignments =
            this.assignments?.filter((item) => item.idCode.isSelected == true);
          this.selected.forEach((row) => this.selectedRowIds.add(row.billCode));

          this.spinner.hide();
        },
        (error) => {
          Swal.fire({
            title: "Error! " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
    } else {
      this.selectedDealerId = "";
      this.assignments = [];
      this.allAssignments = [];
      this.selected = this.selectedBillAssignments = [];
    }
  }

  loadDispatchPreview() {
    const modalRef = this.modalService.open(DispatchBillsPreviewComponent, {
      windowClass: "modal",
      size: "lg",
    });

    modalRef.componentInstance.allAssignments = this.getSelectedRows();
    modalRef.componentInstance.operation = this.selectedDispatch
      ? "Actualización"
      : "Creación";
    modalRef.componentInstance.dispatchName = this.searchForm.get("name").value;
    modalRef.componentInstance.dealer = this.GetDealer();
    modalRef.componentInstance.dispatchId = this.dispatchId
      ? this.dispatchId
      : null;

    modalRef.result.then((result) => {
      const result01 = result as PreviewDispatchResult;
      if (result01.status) {
        this.cleanAfterPreviewAproved();
        if (result01.action === "add") {          
          this.cleanDispatchFields();
        } else {          
          this.FetchModels();
        }
      }
    });
  }

  cleanAfterPreviewAproved(){
    this.selectedRowIds.clear();
    this.assignments = [];
    this.allAssignments = [];
    this.selected = [];
  }

  createDispatch() {
    this.spinner.show();
    if (this.dispatchId) {
      const request: UpdateDispatchToDealerRQ = {
        dealerId: +this.selectedDealerId,
        billsId: this.selectedBillAssignments.map((item) => item.billId),
        dispatchId: +this.dispatchId,
        name: this.searchForm.get("name").value,
      };

      this.assigmentService
        .apiUpdateAssigmentForDispatchPost(request)
        .subscribe(
          (response) => {
            if (response.status == 200) {
              this.spinner.hide();
              Swal.fire({
                title: `El despacho ha sido actualizado satistactoriamente.`,
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
                position: "top",
              });

              setTimeout(() => {
                this.FetchModels();
              }, 3005);
            } else {
              Swal.fire({
                title: "Error! " + response.message,
                icon: "error",
                showConfirmButton: false,
                timer: 3000,
                position: "top-end",
              });
              this.spinner.hide();
            }
          },
          (error) => {
            Swal.fire({
              title: "Error! " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 3000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        );
    } else {
      const request: AddDispatchToDealerRQ = {
        dealerId: +this.selectedDealerId,
        billsId: this.selectedBillAssignments.map((item) => item.billId),
        name: this.searchForm.get("name").value,
      };

      this.assigmentService.apiAddAssigmentForDispatchPost(request).subscribe(
        (response) => {
          if (response.status == 200) {
            this.spinner.hide();
            Swal.fire({
              title: `El despacho ha sido creado satistactoriamente.`,
              icon: "success",
              showConfirmButton: false,
              timer: 3000,
              position: "top",
            });

            setTimeout(() => {
              this.FetchModels();
            }, 3005);
          } else {
            Swal.fire({
              title: "Error! " + response.message,
              icon: "error",
              showConfirmButton: false,
              timer: 3000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        },
        (error) => {
          Swal.fire({
            title: "Error! " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 3000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
    }
  }

  UpdateDealerById(id) {
    this.searchForm.get("dealerId").setValue(id);
    this.selectedDealerId = id;
  }

  getSelectedRows() {
    return this.assignments.filter((row) =>
      this.selectedRowIds.has(row.billCode)
    );
  }

  async FetchDispatch() {
    let request: GetDispatchByIdRQ = {
      dispatchId: +this.dispatchId,
    };
    this.assigmentService
      .apiAssigmentGetDispatchByIdPost(request)
      .toPromise()
      .then((response) => {
        this.selectedDispatch = response.item;
        this.UpdateFormFields();

        const request: GetBillsForDispatchRQ = {
          dealerId: this.selectedDealerId ? +this.selectedDealerId : null,
          dispatchId: this.dispatchId ? +this.dispatchId : null,
          isForUpdate: this.dispatchId ? true : false,
        };

        this.assigmentService
          .apiAssigmentListForDispatchPost(request)
          .subscribe(
            (response) => {
              this.assignments = this.ModelParse(response.list);
              this.allAssignments = this.ModelParse(response.list);
              this.selected = this.selectedBillAssignments =
                this.assignments.filter(
                  (item) => item.idCode.isSelected == true
                );
              this.selected.forEach((row) =>
                this.selectedRowIds.add(row.billCode)
              );
              this.spinner.hide();
            },
            (error) => {
              Swal.fire({
                title: "Error! " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
              this.spinner.hide();
            }
          );
      });
  }

  async FetchModels() {
    this.spinner.show();
    const request: GetBillsForDispatchRQ = {
      dealerId: this.selectedDealerId ? +this.selectedDealerId : null,
      dispatchId: this.dispatchId ? +this.dispatchId : null,
      isForUpdate: this.dispatchId ? true : false,
    };

    this.assigmentService.apiAssigmentListForDispatchPost(request).subscribe(
      (response) => {
        this.assignments = this.ModelParse(response.list);
        this.allAssignments = this.ModelParse(response.list);
        this.selected = this.selectedBillAssignments = this.assignments.filter(
          (item) => item.idCode.isSelected == true
        );      
        this.selected.forEach((row) => this.selectedRowIds.add(row.billCode));  
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  GetURLById(id: number) {
    const bill = this.assignments.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.billFile;
  }

  GetCodeById(id: number) {
    const bill = this.assignments?.find((b) => b.billId === id);
    return bill.billCode;
  }

  GetServiceCodeById(id: number) {
    const bill = this.assignments?.find((b) => b.billId === id);
    return bill.serviceCode;
  }

  totalPounds() {
    if (this.assignments?.length > 0) {
      let sum = this.assignments.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.billPounds).toFixed(2));
      }, 0);
      return sum;
    }
    return 0;
  }

  totalPaid() {
    let sum = this.assignments.reduce((accumulator, item) => {
      return accumulator + Number(item.billTotal.toFixed(2));
    }, 0);
    return sum;
  }

  ModelParse(array: AssigmentDealerModel[]): AssigmentDealerLocalModel[] {
    return array?.map(
      ({
        billCustomerModel,
        billSenderModel,
        billId,
        id,
        inUpdate,
        shippingType,
        ...rest
      }) => ({
        ...rest,
        billId: billId,
        id: id,
        shippingType: shippingType,
        shippingTypeName: this.GetNameShippingType(shippingType),
        idCode: {
          billId: billId,
          id: id,
          isSelected: inUpdate,
        },
        billCustomerModel: JSON.parse(billCustomerModel || ""),
        billSenderModel: JSON.parse(billSenderModel || ""),
      })
    );
  }

  /*onSelect({ selected }) {   
    console.log(this.selected); 
    console.log(selected)
    this.selectedBillAssignments = selected as AssigmentDealerLocalModel[];
    this.selectedAssignment =
    this.selectedBillAssignments[this.assignments.length - 1];    
  }*/

  onSelect({ selected }: { selected: any[] }) {
    //console.log(this.selected);
    //console.log(selected)
    selected.forEach((row) => this.selectedRowIds.add(row.billCode));
    this.assignments
      .filter((row) => !selected.some((sel) => sel.id === row.id))
      .forEach((row) => this.selectedRowIds.delete(row.billCode));
  }

  onCheckboxChangeFn({ selected }, idCode) {}

  public onCheckboxChange(event: any, row: any): void {
    console.log("entre aqui");
    if (this.getChecked(row) === false) {
      // add
      this.selected.push(row);
    } else {
      // remove
      for (let i = 0; i < this.selected.length; i++) {
        if (
          this.selected[i].id === row.id &&
          this.selected[i].site_code === row.site_code
        ) {
          this.selected.splice(i, 1);
          break;
        }
      }
    }
  }

  public getChecked(row: any): boolean {
    // autofill checked
    console.log(row);
    console.log(this.selected);
    const item = this.selected.filter((e) => e.id === row.id);
    return item.length > 0 ? true : false;
  }
}
